import { Link, useNavigate } from "react-router-dom";
import { useStore } from "../../stores/root-store-context";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { Button, Spin } from "antd";
import { AddTimeReport } from "../../pages/TimeReports/AddTimeReport";
import { useEffect, useState } from "react";
import {
    ApiOutlined,
    ClockCircleOutlined,
    FileSearchOutlined,
} from "@ant-design/icons";
import TimerBlock from "../blocks/TimerBlock";
import { Roles } from "../../enums/Roles";

const Menu: React.FC = observer(() => {
    const { applicationStore, projectsStore } = useStore();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [refresh, setRefresh] = useState(false);

    const showModal = () => setIsModalOpen(true);

    function useEnsureProjectsLoaded() {
        const { applicationStore, projectsStore } = useStore();
        useEffect(() => {
            if (!applicationStore.isAuthenticated) return;
            if (!applicationStore.company?.Id) return;
            if (projectsStore.projects.length === 0 && !projectsStore.isLoading) {
                projectsStore.getAll(true);
            }
        }, [
            applicationStore.isAuthenticated,
            applicationStore.company?.Id
        ]);
    }

    useEnsureProjectsLoaded();

    const hideModal = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <ul>
                {!applicationStore.isAuthenticated ?
                    <>
                        <li>
                            <Link to={"/AboutCompany"}>{t('Menu.AboutUs')}</Link>
                        </li>
                        <li>
                            <Link to={"/prices"}>{t('Menu.Prices')}</Link>
                        </li>
                        <li>
                            <Link to={"/api-list"}>{t('API')} <ApiOutlined style={{ marginRight: '5px' }} /></Link>
                        </li>
                        <li>
                            <Link to={"/documentation/docs/en/index.html"} target="_blank">{t('Documentation')} <FileSearchOutlined style={{ marginRight: '5px' }} /></Link>
                        </li>
                    </> : <></>
                }
                {applicationStore.isAuthenticated ?
                    <>
                        <li>
                            <Link to={"/" + applicationStore.company?.Tenant}>{t('Menu.MyCompany')}</Link>
                        </li>
                        <li>
                            <Link to={"/" + applicationStore.company?.Tenant + "/employees"}>{t("Menu.Employees")}</Link>
                        </li>
                        <li>
                            <Link to={"/" + applicationStore.company?.Tenant + "/projects"}>{t("Menu.Projects")}</Link>
                        </li>

                        <li>
                            <Link to={"/" + applicationStore.company?.Tenant + "/tests"}>{t("Menu.Tests")}</Link>
                        </li>

                        <li>
                            <div style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                                <Link
                                    to={`/${applicationStore.company?.Tenant}/time-reports`}
                                    style={{ display: "inline-flex", alignItems: "center" }}
                                >
                                    {t("Menu.Events")}
                                </Link>

                                <Spin
                                    spinning={projectsStore.isLoading}
                                    style={{ display: "inline-flex", alignItems: "center" }}
                                >
                                    <Button
                                        type="link"
                                        shape="circle"
                                        onClick={showModal}
                                        icon={<ClockCircleOutlined style={{ fontSize: 22 }} />}
                                    />
                                    {applicationStore.user.id && <TimerBlock />}
                                </Spin>
                            </div>
                        </li>
                        
                        <li>
                            <Link to={"/" + applicationStore.company?.Tenant + "/time-reports/Calendar"}>{t("Calendar")}</Link>
                        </li>
                        {applicationStore.user?.roles?.some(role => [Roles.Financier, Roles.Owner].includes(role.id)) && (
                            <li>
                                <Link to={"/" + applicationStore.company?.Tenant + "/employees/salaries"}>{t("Menu.Salaries")}</Link>
                            </li>
                        )}
                    </> : <></>
                }
                {applicationStore.isAuthenticated ?
                    <li></li> :
                    <>
                        <li>
                            <div >
                                <button className="theme-btn" onClick={() => {
                                    localStorage.removeItem('token');
                                    navigate('/register-company');

                                }}>
                                    <span>
                                        {t("RegisterCompany")}
                                        <i className="fa-solid fa-arrow-right-long" />
                                    </span>
                                </button>
                            </div></li><li>
                            <div >
                                <button className="theme-btn" onClick={() => {
                                    navigate("/login");
                                }}>
                                    <span>
                                        {t("SignIn")}
                                        <i className="fa-solid fa-arrow-right-long" />
                                    </span>
                                </button>
                            </div>
                        </li>
                    </>}
            </ul>
            <AddTimeReport isModalOpen={isModalOpen} hideModal={hideModal} userId={applicationStore.user?.id}
                isChangeUser={applicationStore.user?.roles?.some(role => [Roles.Owner, Roles.Admin].includes(role.id)) ?? false} refresh={refresh}
                setRefresh={setRefresh} />
        </>
    )
});

export default Menu;
